import directionTopIcon from "../../src/assets/images/Synchro/icons/direction-top.png";
import directionRightIcon from "../../src/assets/images/Synchro/icons/direction-right.png";
import directionBottomIcon from "../../src/assets/images/Synchro/icons/direction-bottom.png";
import directionleftIcon from "../../src/assets/images/Synchro/icons/direction-left.png";

/**
 * 1: direction-top
 * 2: direction-right
 * 3: direction-bottom
 * 4: direction-left
 */ 


export const getIconDirection = (direction) => {
    switch (direction) {
        case 1: return directionTopIcon;
        case 2: return directionRightIcon;
        case 3: return directionBottomIcon;
        case 4: return directionleftIcon;
    }
    

};